/**
 * Fetcher Setting
 * @author Tevin
 */

import { Fetcher } from '@components/bases/Fetcher';
import MenuPathTree from '@fetchers/datas/MenuPathTree';

export class FSetting extends Fetcher {
    constructor() {
        super({
            urlPrefix: ['/api/setting/', '/Home/Setting/'],
            mockPath: MenuPathTree.projectName,
        });
    }

    // 获取微信公众号域名验证文件专用上传地址（微信公众号）
    getUploadWXVerifyURLSpell() {
        return this.spellURL('../common/uploadFile', 'upload_file');
    }

    // 获取微信支付证书文件专用上传地址（支付证书）
    getUploadWXPaymentURLSpell() {
        return this.spellURL('../common/uploadFile', 'upload_cert');
    }

    // 获取工行支付密钥文件专用上传地址（支付证书）
    getUploadICBCPaymentURLSpell() {
        return this.spellURL('../common/uploadFile', 'upload_yourpri');
    }

    // 获取积分策略（积分策略）
    getScoreStrategy() {
        const url = this.spellURL('getScoreStrategy', '../../lpg/admin/Setting/currency');
        const send = {};
        return this.post(url, send);
    }

    // 保存积分策略（积分策略）
    saveScoreStrategy(currency) {
        const url = this.spellURL('saveScoreStrategy', '../../lpg/admin/Setting/saveCurrency');
        const send = {
            ...currency,
        };
        return this.post(url, send);
    }

    // 获取上层费列表（上楼费）
    getFloorFeeList(search) {
        const url = this.spellURL('getFloorFeeList', '../../lpg/admin/Setting/floorList');
        const send = {
            ...this.transKeyName('underline', search),
            page: 1,
            limit: 9000,
        };
        return this.post(url, send);
    }

    // 获取上楼费开关状态（上楼费）
    getFloorFeeValve() {
        const url = this.spellURL('getFloorFeeValve', '../../lpg/admin/Setting/floorStatus');
        const send = {};
        return this.post(url, send);
    }

    // 保存上楼费开关状态（上楼费）
    saveFloorFeeValve(valve) {
        const url = this.spellURL('saveFloorFeeValve', '../../lpg/admin/Setting/saveFloor');
        const send = {
            ...this.transKeyName('underline', valve),
        };
        return this.post(url, send);
    }

    // 保存上楼费信息（上楼费）
    saveFloorFeeInfo(info) {
        const url = this.spellURL('saveFloorFeeInfo', '../../lpg/admin/Setting/saveFloor');
        const send = {
            ...this.transKeyName('underline', info),
        };
        return this.post(url, send);
    }

    // 获取配送设置（配送设置）
    getDeliverySetting() {
        const url = this.spellURL(
            'getDeliverySetting',
            '../../lpg/admin/Setting/getDispatchSettings',
        );
        const send = {};
        return this.post(url, send);
    }

    // 保存配送设置（配送设置）
    saveDeliverySetting(delivery) {
        const url = this.spellURL(
            'saveDeliverySetting',
            '../../lpg/admin/Setting/saveDispatchSettings',
        );
        const { pickStore, siteJoin, pickJoin, ...resetDelivery } = delivery;
        const send = {
            ...this.transKeyName('underline', resetDelivery),
            pickStore,
            siteJoin,
            pickJoin,
        };
        return this.post(url, send);
    }

    // 读取临时欠瓶允许的会员类型（配送设置）
    getTempBottleUserType() {
        const url = this.spellURL('getTempBottleUserType', '../../lpg/admin/Setting/bottleMemberTypes');
        const send = {};
        return this.post(url, send);
    }

    // 保存临时欠瓶允许的会员类型（配送设置）
    saveTempBottleUserType(types) {
        const url = this.spellURL('saveTempBottleUserType', '../../lpg/admin/Setting/saveBottleMemberTypes');
        const send = {
            ...types,
        };
        return this.post(url, send);
    }

    // 保存开户会员类型-选择会员类型（配送设置）
    saveOpenAccountUserType(data) {
        const url = this.spellURL(
            'saveOpenAccountUserType',
            '../../lpg/admin/Setting/editAllowMemType',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 读取App设置（App设置）
    getAppSettings() {
        const url = this.spellURL('getAppSettings', '../../lpg/admin/Setting/appMenu');
        const send = {};
        return this.post(url, send);
    }

    // 读取App设置（App设置）
    saveAppSettings(settings) {
        const url = this.spellURL('saveAppSettings', '../../lpg/admin/Setting/saveAppMenu');
        const send = {
            ...this.transKeyName('underline', settings),
        };
        return this.post(url, send);
    }

    // 读取气瓶使用费
    getBottleRoyalties(type) {
        const url = this.spellURL('getBottleRoyalties', '../../lpg/admin/Setting/bottleRoyalties');
        const send = {
            ...type,
        };
        return this.post(url, send);
    }

    // 保存气瓶使用费
    saveBottleRoyalties(royalty) {
        const url = this.spellURL('saveBottleRoyalties', '../../lpg/admin/Setting/saveBottleRoyalties');
        const send = {
            ...this.transKeyName('underline', royalty),
        };
        return this.post(url, send);
    }

    // 获取开户须知（开户须知）
    getUserRegAgreement() {
        const url = this.spellURL('getRegAgreement', '../../lpg/admin/Setting/userNotice');
        const send = {};
        return this.post(url, send);
    }

    // 保存开户须知（开户须知）
    saveUserRegAgreement(content) {
        const url = this.spellURL('saveRegAgreement', '../../lpg/admin/Setting/userNotice');
        const send = {
            notice: content,
        };
        return this.post(url, send);
    }

    // 获取气瓶一瓶一码设置（一瓶一码）
    getBottleUniqueSetting() {
        const url = this.spellURL('getBottleUniqueSetting', '../Gangping/Check_setting');
        const send = {};
        return this.post(url, send, {
            remap: [
                ['', 'companyabstract', 'companyAbstract'],
                ['', 'companyname', 'companyName'],
            ],
        });
    }

    // 保存气瓶一瓶一码设置（一瓶一码）
    saveBottleCodeSetting(setting) {
        const url = this.spellURL('saveBottleUniqueCode', '../Gangping/Change_setting');
        const send = {
            ...this.transKeyName('underline', this.trimEndsSpace(setting)),
        };
        return this.post(url, send);
    }

    // 获取支付方式设置（支付方式）
    getPaymentMode() {
        const url = this.spellURL('getPaymentMode', '../../lpg/admin/Setting/payType');
        const send = {};
        return this.post(url, send);
    }

    // 保存支付方式设置（支付方式）
    savePaymentMode(setting) {
        const url = this.spellURL('savePaymentMode', '../../lpg/admin/Setting/savePayType');
        const send = {
            ...this.transKeyName('underline', setting),
        };
        return this.post(url, send);
    }

    // 获取微信支付立减区域（支付方式）
    getWxPayModeUseArea() {
        const url = this.spellURL('getWxPayModeUseArea', '../../lpg/admin/Setting/wxpayVoucherAreaList');
        const send = {};
        return this.post(url, send);
    }

    // 保存微信支付立减区域在线状态（支付方式）
    saveWxPayModeUseAreaOnline(area) {
        const url = this.spellURL('saveWxPayModeUseAreaOnline', '../../lpg/admin/Setting/saveWxpayVoucherArea');
        const send = {
            ...this.transKeyName('underline', area),
        };
        return this.post(url, send);
    }

    // 保存微信支付立减区域（支付方式）
    saveWxPayModeUseArea(area) {
        const url = this.spellURL('saveWxPayModeUseArea', '../../lpg/admin/Setting/saveWxpayVoucherArea');
        const send = {
            ...area,
        };
        return this.post(url, send);
    }

    // 获取月结的会员类型（支付方式）
    getMonthPayUserTypes() {
        const url = this.spellURL('getMonthPayUserTypes', '../../lpg/admin/Setting/monthPayMemberTypes');
        const send = {};
        return this.post(url, send);
    }

    // 保存月结的会员类型（支付方式）
    saveMonthPayUserType(typeData) {
        const url = this.spellURL('saveMonthPayUserType', '../../lpg/admin/Setting/saveMonthPayMemberType');
        const send = {
            ...typeData,
        };
        return this.post(url, send);
    }

    // 获取微信公众号绑定设置（微信公众号）
    getWxOfficialAcc() {
        const url = this.spellURL('getWxOfficialAcc', '../../lpg/admin/Setting/wxSetting');
        const send = {};
        return this.post(url, send);
    }

    // 保存微信公众号绑定设置（微信公众号）
    saveWxOfficialAcc(official) {
        const url = this.spellURL('saveWxOfficialAcc', '../../lpg/admin/Setting/saveWxSetting');
        const send = {
            ...this.transKeyName('underline', official),
        };
        return this.post(url, send);
    }

    // 获取微信菜单设置（微信菜单）
    getWxMenuSetting() {
        const url = this.spellURL('getWxMenuSetting', '../../lpg/admin/Setting/wxMenu');
        const send = {};
        return this.post(url, send);
    }

    // 保存微信菜单设置（微信菜单）
    saveWxMenuSetting(setting) {
        const url = this.spellURL('saveWxMenuSetting', '../../lpg/admin/Setting/publishWxMenu');
        const send = {
            menu: setting,
        };
        return this.post(url, send);
    }

    // 获取微信红包设置（微信红包）
    getWxRedPacketSetting() {
        const url = this.spellURL('getWxRedPacketSetting', '../../lpg/admin/Hongbao/hongbao_info');
        const send = {};
        return this.post(url, send);
    }

    // 保存微信红包设置（微信红包）
    saveWxRedPacketSetting(redPacket) {
        const url = this.spellURL('saveWxRedPacketSetting', '../../lpg/admin/Hongbao/saveCfg');
        const send = {
            ...this.transKeyName('underline', redPacket),
        };
        return this.post(url, send);
    }

    // 保存微信红包功能开关状态（微信红包）
    saveWxRedPacketValve(redPacket) {
        const url = this.spellURL('saveWxRedPacketValve', '../../lpg/admin/Hongbao/hongbao_status');
        const send = {
            ...redPacket,
        };
        return this.post(url, send);
    }

    // 获取微信消息模版列表（微信消息模版）
    getWxMsgTemplates(search, pagination, sorter) {
        const url = this.spellURL('getWxMsgTemplates', '../../lpg/admin/Setting/getMsgModelList');
        const send = {
            ...search,
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 保存删除微信消息模版（微信消息模版）
    saveDeleteWxMsgTemplate(template) {
        const url = this.spellURL(
            'saveDeleteWxMsgTemplate',
            '../../lpg/admin/Setting/deleteMsgModel',
        );
        const send = {
            ...this.transKeyName('underline', template),
        };
        return this.post(url, send);
    }

    // 保存初始化微信消息模版（微信消息模版）
    saveInitWxMsgTemplate(template) {
        const url = this.spellURL('saveWxMsgTemplateInit', '../../lpg/admin/Setting/initMsgModel');
        const send = {
            ...this.transKeyName('underline', template),
        };
        return this.post(url, send);
    }

    // 获取微信模版 ID 列表（微信消息模版）
    getWxMsgTemplateIdsAsSelect() {
        const url = this.spellURL(
            'getWxMsgTemplateIdFilter',
            '../../lpg/admin/Setting/getMsgModelInfo',
        );
        const send = {};
        return this.post(url, send);
    }

    // 保存微信模版信息（微信模版）
    saveAddWxMsgTemplateInfo(template) {
        const url = this.spellURL('saveWxMsgTemplateInfo', '../../lpg/admin/Setting/addMsgModel');
        const send = {
            ...this.transKeyName('underline', template),
        };
        return this.post(url, send);
    }

    // 保存更新微信模版信息（微信模版）
    saveUpdateWxMsgTemplateInfo(template) {
        const url = this.spellURL(
            'saveUpdateWxMsgTemplateInfo',
            '../../lpg/admin/Setting/editMsgModel',
        );
        const send = {
            ...this.transKeyName('underline', template),
        };
        return this.post(url, send);
    }

    // 读取微信支付证书信息（支付证书）
    getWxPaymentCertificate() {
        const url = this.spellURL('getWxPaymentCertificate', 'get_wpay_detail');
        const send = {};
        return this.post(url, send, {
            remap: [
                ['', 'fapikey', 'apikey'],
                ['', 'fmchid', 'mchid'],
                ['', 'fcertp12', 'certp12'],
                ['', 'fcertpem', 'certpem'],
                ['', 'fkeypem', 'keypem'],
            ],
        });
    }

    // 保存微信支付证书信息（支付证书）
    saveWxPaymentCertificate(cert) {
        const url = this.spellURL(
            'saveWxPaymentCertificate',
            '../../lpg/admin/Setting/update_wpay_detail',
        );
        const send = {
            ...cert,
        };
        return this.post(url, send);
    }

    // 获取聚合支付证书信息（支付证书）
    getUnionPayCertificate() {
        const url = this.spellURL('getUnionPayCertificate', 'get_unionpay_detail');
        const send = {};
        return this.post(url, send);
    }

    // 保存聚合支付证书信息（支付证书）
    saveUnionPayCertificate(cert) {
        const url = this.spellURL('saveUnionPayCertificate', 'update_unionpay_detail');
        const send = {
            ...this.transKeyName('underline', cert),
        };
        return this.post(url, send);
    }

    // 获取收钱吧商户聚合总配（支付证书 channel=6）
    getUnionConfig(data = {}) {
        const url = this.spellURL(
            'getUnionConfig',
            '../../lpg/admin/Setting/getUnionConfig',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 保存收钱吧商户聚合总配（支付证书 channel=6）
    saveUnionConfig(cfg) {
        const url = this.spellURL(
            'saveUnionConfig',
            '../../lpg/admin/Setting/saveUnionConfig',
        );
        const send = {
            ...this.transKeyName('underline', cfg),
        };
        return this.post(url, send);
    }

    // 收钱吧手动激活（商户总配 union_config=1 / 门店 account_id）
    saveActivateShouqianba(data) {
        const url = this.spellURL(
            'saveActivateShouqianba',
            '../../lpg/admin/store/activateShouqianba',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取生成交易密钥（支付证书）
    getGenerateTradeKey() {
        const url = this.spellURL(
            'getGenerateTradeKey',
            '../../lpg/admin/Setting/generateRsaTradeKeys',
        );
        const send = {};
        return this.post(url, send);
    }

    // 获取开户短信配置（开户短信）
    getSMSSetting() {
        const url = this.spellURL('getSMSSetting', 'sms_info');
        const send = {};
        return this.post(url, send);
    }

    // 保存开户短信配置（开户短信）
    saveSMSSetting(sms) {
        const url = this.spellURL('saveSMSSetting', 'sms_setting');
        const { signName, templateCode, ...resetSms } = sms;
        const send = {
            ...resetSms,
            sign_name: signName,
            template_code: templateCode,
        };
        return this.post(url, send);
    }

    // 获取 v8 接口对接设置（V8对接）
    getV8DockingSetting() {
        const url = this.spellURL('getV8DockingSetting', '../../lpg/admin/Setting/v8Info');
        const send = {};
        return this.post(url, send);
    }

    // 保存 v8 接口对接设置（V8对接）
    saveV8DockingSetting(setting) {
        const url = this.spellURL('saveV8DockingSetting', '../../lpg/admin/Setting/saveV8');
        const send = {
            ...this.transKeyName('underline', setting),
        };
        return this.post(url, send);
    }

    // 获取数据维护上传文件接口（数据维护）
    getDataMaintenanceUploadURL() {
        return this.spellURL('../common/uploadFile', '../Upload/upload');
    }

    // 气瓶档案数据维护接口（数据维护）
    saveMaintainArchive(data) {
        const url = this.spellURL('saveMaintainArchive', '../Gangping/maintainArchive');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 充装数据维护接口（数据维护）
    saveMaintainRecord(data) {
        const url = this.spellURL('saveMaintainRecord', '../Gangping/maintainRecord');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 会员导入维护接口（数据维护）
    saveMaintainUserImport(data) {
        const url = this.spellURL('saveMaintainUserImport', '../../lpg/admin/member/importMember');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 查询充装数据上传任务执行结果
    getExportArchiveResult(resultId) {
        const url = this.spellURL('getExportArchiveResult', '../Gangping/getExportArchiveResult');
        const send = {
            ...this.transKeyName('underline', resultId),
        };
        return this.post(url, send);
    }

    // 查询异步导出进度
    getExportResult(data) {
        const url = this.spellURL('getExportResult', '../../lpg/admin/getExportResult');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取开放接口列表
    getOpenInterfaceList(sendData) {
        const url = this.spellURL('getOpenInterfaceList', '../../lpg/admin/Setting/openCfg');
        const send = {
            ...this.transKeyName('underline', sendData),
        };
        return this.post(url, send);
    }

    // 获取配送计件价格配置列表（配送计件价格配置）
    getDeliveryPieceworkCfg() {
        const url = this.spellURL(
            'getDeliveryPieceworkCfg',
            '../../lpg/admin/Delivery/pieceworkCfg',
        );
        return this.post(url);
    }

    // 保存添加配送计件价格配置（配送计件价格配置）
    saveAddDeliveryPieceworkCfg(data) {
        const url = this.spellURL(
            'saveAddDeliveryPieceworkCfg',
            '../../lpg/admin/Delivery/addPieceworkCfg',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 保存编辑配送计件价格配置（配送计件价格配置）
    saveEditDeliveryPieceworkCfg(data) {
        const url = this.spellURL(
            'saveEditDeliveryPieceworkCfg',
            '../../lpg/admin/Delivery/editPieceworkCfg',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取营业员工资配置列表（营业员工资配置）
    getSalespersonSalaryCfg(search, pagination, sorter) {
        const url = this.spellURL(
            'getSalespersonSalaryCfg',
            '../../lpg/admin/setting/salesSalary/getList',
        );
        const send = {
            ...this.transKeyName('underline', search),
            page_num: pagination.current,
            page_size: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 保存添加营业员工资配置（营业员工资配置）
    saveEditSalespersonSalaryCfg(data) {
        const url = this.spellURL(
            'saveEditSalespersonSalaryCfg',
            '../../lpg/admin/setting/salesSalary/addConfig',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 保存删除营业员工资配置（营业员工资配置）
    saveDelSalespersonSalaryCfg(data) {
        const url = this.spellURL(
            'saveDelSalespersonSalaryCfg',
            '../../lpg/admin/setting/salesSalary/deleteConfig',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 保存账号工资配置（账号列表）
    saveAccountSalaryCfg(data) {
        const url = this.spellURL(
            'saveAccountSalaryCfg',
            '../../lpg/admin/setting/salesSalary/setBzAdmin',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取字段类型、工资类型列表
    getSalaryCfgFieldAsSelect() {
        const url = this.spellURL(
            'getSalaryCfgFieldAsSelect',
            '../../lpg/admin/setting/salesSalary/getParams',
        );
        const send = {};
        return this.post(url, send);
    }

    // 获取短信模板列表（短信配置）
    getSmsTemplateList(search, pagination, sorter) {
        const url = this.spellURL(
            'getSmsTemplateList',
            '../../lpg/admin/Setting/getSmsTemplateList',
        );
        const send = {
            ...this.transKeyName('underline', {
                ...search,
                page: pagination.current,
                pageSize: pagination.pageSize,
            }),
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 保存短信模板（短信配置）
    saveSmsTmpConfigInfo(data) {
        const url = this.spellURL(
            'saveSmsTmpConfigInfo',
            '../../lpg/admin/Setting/saveSmsTemplate',
        );
        const send = {
            ...this.transKeyName('underline', data),
            accessKeyId: data.accessKeyId,
            accessKeySecret: data.accessKeySecret,
        };
        delete send.access_key_id;
        delete send.access_key_secret;
        return this.post(url, send);
    }

    // 保存短信配置状态（短信配置）
    saveSetSmsTmpConfigStatus(data) {
        const url = this.spellURL(
            'saveSetSmsTmpConfigStatus',
            '../../lpg/admin/Setting/toggleSmsTemplateStatus',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取已经开启的短信模板（短信配置，随瓶安检设置）
    getEnabledSmsTemplateOptions() {
        const url = this.spellURL(
            'getEnabledSmsTemplateOptions',
            '../../lpg/admin/Setting/getEnabledSmsTemplateOptions',
        );
        const send = {};
        return this.post(url, send);
    }

    // 根据短信类型获取短信模板列表（短信配置，随瓶安检设置）
    getEnabledTemplatesByType(type) {
        const url = this.spellURL(
            'getEnabledTemplatesByType',
            '../../lpg/admin/Setting/getEnabledTemplatesByType',
        );
        const send = {
            ...this.transKeyName('underline', type),
        };
        return this.post(url, send);
    }

    // 获取客户短信发送列表（客户短信发送）
    getCustomerSmsSendList(search, pagination, sorter) {
        const url = this.spellURL(
            'getCustomerSmsSendList',
            '../../lpg/admin/Setting/getSmsRecords',
        );
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            page_size: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 保存取消发送短信（客户短信发送）
    saveCancelSendSmsByBatchUser(data) {
        const url = this.spellURL(
            'saveCancelSendSmsByBatchUser',
            '../../lpg/admin/Setting/batchCancelSms',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 保存取消发送短信（客户短信发送）
    saveCancelSendSmsByAllUser(data) {
        const url = this.spellURL(
            'saveCancelSendSmsByAllUser',
            '../../lpg/admin/Setting/cancelSms',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 保存批量发送短信（客户短信发送）
    saveSendSmsByBatchUser(data) {
        const url = this.spellURL(
            'saveSendSmsByBatchUser',
            '../../lpg/admin/Setting/batchSendSmsById',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 保存全部发送短信（客户短信发送）
    saveSendSmsByAllUser(data) {
        const url = this.spellURL(
            'saveSendSmsByAllUser',
            '../../lpg/admin/Setting/batchSendSmsByCondition',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取微信用户会话列表（公众号消息）
    getUserSessionList(data) {
        const url = this.spellURL('getUserSessionList', '../../lpg/admin/wechat/getSessions');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取微信消息列表（公众号消息）
    getUserMessageList(data) {
        const url = this.spellURL('getUserMessageList', '../../lpg/admin/wechat/messages');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 保存发送微信消息（公众号消息）
    saveSendWechatMessage(data, messageType) {
        const url = this.spellURL('saveSendWechatMessage', '../../lpg/admin/wechat/send');
        let send;

        // 判断是否为FormData对象
        if (data instanceof FormData) {
            // 直接使用FormData
            send = data;
            // 发送FormData需要特殊处理请求头，覆盖默认配置
            const options = {
                headers: {
                    'Ax-Rq-Type': 'separation',
                    // 不要设置Content-Type，让浏览器自动设置multipart/form-data边界
                },
            };
            return this.query('post', url, send, [], options);
        } else {
            // 普通对象，转换后发送
            send = {
                ...this.transKeyName('underline', data),
            };
            return this.post(url, send);
        }
    }

    // 获取安检图片保留周期收款订单（配送设置）
    getSecurityImgRetentionPayOrder(data) {
        const url = this.spellURL(
            'getSecurityImgRetentionPayOrder',
            '../../lpg/admin/Setting/createSecurityImgRetentionPayOrder',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取安检周期保留周期数据（配送设置）
    getSecurityImgRetentionPeriod() {
        const url = this.spellURL(
            'getSecurityImgRetentionPeriod',
            '../../lpg/admin/Setting/getSaveLastImgPayPermissions',
        );
        return this.post(url, {});
    }
}

export const $fetchSetting = new FSetting();
